import {MultiLanguageString} from "./multi-language-string";
import {IBehaviouralIndicator} from "./i-behavioural-indicator";

export class BehaviouralIndicator {
    public constructor(public description: MultiLanguageString) {
    }

    public static fromInterface(iBehaviouralIndicator: IBehaviouralIndicator): BehaviouralIndicator {
        return new BehaviouralIndicator(MultiLanguageString.fromInterface(iBehaviouralIndicator.description));
    }
}
